module.exports = __webpack_public_path__ + "static/media/StagebegeleiderFeedback.cea3d171.pdf";